import service from '../service'
import {allPath} from '../router/routeConfig'
let mixMethods = {
  data:function(){

      return{
          // isLogin:false
          lock: false,
          initTime: new Date().getTime()
      }
  },
  created() {
    // if(localStorage.getItem('refreshToken')){
    //   this.isLogin = true
    // }else{
    //   this.isLogin = false
    // }
  },
  methods: {
    $navigateTo(name,params,webnav,type){
      
      let str = this.objToUrl(params)
      
      let path = this.getPath(name)
      
      if(this.$platform === "miniProgram"){
        let refreshToken = localStorage.getItem(this.$env+"refreshToken")
        if(this.getAuth(name) && !refreshToken){
          console.log(type,'type')
          try{
            const {aplus_queue} = window;
            console.log(aplus_queue,window)
            aplus_queue.push({
              action: 'aplus.sendPV',
              arguments: [{ is_auto: false } , params.reurl]
            });
          }catch(e){
            console.log(e)
          }
          if(type === "redirecto"){
            let param = {urlstr:params.reurl}
            let strs = this.objToUrl(param)
            let pagefrom = this.getPath(name)
            
            this.$wx.miniProgram.redirectTo({url:`/pages/login/login?pagefrom=${pagefrom}&${strs}`})
          }else if(type === "switchTab"){
            let param = {urlstr:params.reurl}
            let strs = this.objToUrl(param)
            let pagefrom = this.getPath(name)
            
            this.$wx.miniProgram.switchTab({url:`/pages/login/login?pagefrom=${pagefrom}&${strs}`})
          }else{
            // let params = {
            //     urlstr: name,
            //   }
            let pagefrom = this.getPath(name)
            this.$wx.miniProgram.navigateTo({url:`/pages/login/login?pagefrom=${pagefrom}&${str}`})
          }
          return
        }
        let url = path + "?" + str;
        this.$service.getStatisCommon("evn_close_page",{});
        if(webnav){
          this.$router.push({ path: `/${name}`, query: params})
        }else{
          if(this.lock){
            return
          }
          this.lock = true
          this.$wx.miniProgram.navigateTo({
            url: encodeURI(url)
          })
          setTimeout(()=>{
            this.lock = false
          },3000)
        }
        
      }else{
        this.$service.getStatisCommon("evn_close_page",{});
        // this.$dialog.alert({
        //   message: JSON.stringify({ path: path, query: params}),
        // }).then(()=>{
        //   this.$router.push({ path: path, query: params})
        // })
        this.$router.push({ path: path, query: params})
      }
    },
    // $authRedirecto(urlstr,params){
    //   let str = this.objToUrl(params)
      
    //   let path = this.getPath(urlstr)
      
    //   if(this.$platform === "miniProgram"){
    //     let refreshToken = localStorage.getItem("refreshToken")
    //     if(this.getAuth(urlstr) && !refreshToken){
    //       let pagefrom = this.getPath(urlstr)
    //       // if(this.$platform === "miniProgram"){
    //         this.$wx.miniProgram.redirectTo({url:`/pages/login/login?pagefrom=${pagefrom}&${str}`})
    //         return
    //       // }
    //     }
    //     let url = path + "?" + str;
    //     if(webnav){
    //       this.$router.replace({ path: `/${urlstr}`, query: params})
    //     }else{
    //       if(this.lock){
    //         return
    //       }
    //       this.lock = true
    //       this.$wx.miniProgram.redirectTo({
    //         url: encodeURI(url)
    //       })
    //       setTimeout(()=>{
    //         this.lock = false
    //       },3000)
    //     }
        
    //   }else{
    //     this.$router.push({ path: path, query: params})
    //   }
    // },
    $redirectTo(urlstr,params){
      let path = this.getPath(urlstr)
      
      if(this.$platform === "miniProgram"){
        let str = this.objToUrl(params)
        let url = path + "?" + str;
        try{
          const {aplus_queue} = window;
          console.log(aplus_queue,window)
          aplus_queue.push({
            action: 'aplus.sendPV',
            arguments: [{ is_auto: false } , params.reurl]
          });
        }catch(e){
          console.log(e)
        }
        this.$wx.miniProgram.redirectTo({
          url: url
        })
      }else{
        this.$router.replace({ path: path, query: params})
      }
    },
    $reLaunch(urlstr,params){
      let path = this.getPath(urlstr)
      
      if(this.$platform === "miniProgram"){
        let str = this.objToUrl(params)
        let url = path + "?" + str;
        console.log('url',url)
        try{
          const {aplus_queue} = window;
          console.log(aplus_queue,window)
          aplus_queue.push({
            action: 'aplus.sendPV',
            arguments: [{ is_auto: false } , params.reurl]
          });
        }catch(e){
          console.log(e)
        }
        this.$wx.miniProgram.reLaunch({
          url: url
        })
      }else{
        this.$router.replace({ path: path, query: params})
      }
    },
    $login(urlstr){
      if(this.$platform === "miniProgram"){
        if(this.lock){
          return
        }
        let pagefrom = this.getPath(urlstr)
        this.$wx.miniProgram.redirectTo({url:`/pages/login/login?pagefrom=${pagefrom}&urlstr=${urlstr}`})
        setTimeout(()=>{
          this.lock = false
        },3000)
      }else{
        this.$router.push({ path: `/login`})
      }
    },
    objToUrl(obj){
      let arr = Object.keys(obj);
      let str = ""
      arr.forEach(item => {
        str += "&" + item + "=" + obj[item]
      })
      return str.slice(1)
    },
    getPath(name){
      let res = allPath.filter(item => {
        return item.name === name
      })
      return this.$platform === "miniProgram" ? res[0].meta.miniRoute : res[0].path
    },
    getAuth(name){
      let res = allPath.filter(item => {
        return item.name === name
      })
      return !!res[0].meta.auth
    },
    /**
     * @description 埋点方法
     * @param {String} event 埋点事件名称
     * @param {Object} param  埋点参数
     */
    sendStatics:function(event,param){
      // 埋点小程序，不埋点h5
      if(this.$platform != "miniProgram") return
      if(process.env.VUE_APP_TITLE != '') return
      const staticParam = {
        site:2,
        appName:2
      }
      Object.assign(param,staticParam)
      const {aplus_queue} = window;
      aplus_queue.push({
        action: 'aplus.record',
        arguments: [event, 'CLK', param]
      });
    }
  },

}

let methodPlu = {}
methodPlu.install = function(Vue,optionss){
  Vue.mixin(mixMethods)

  Vue.directive('stat', {
    bind(el, binding) {
      el.addEventListener('click', () => {
        const data = binding.value;
  
        service.getStatisCommon(data.event,data.data)

      }, false);
    }
  });
}

export default methodPlu